import { FC } from 'react';
import { DAYS_OF_WEEK } from './constants';
import type { AvailabilitySlot } from '../../../../types/therapist-dashboard.types';

interface WeeklySummaryProps {
  slots: AvailabilitySlot[];
}

export const WeeklySummary: FC<WeeklySummaryProps> = ({ slots }) => {
  const availableDays = slots.filter((s) => s.isAvailable).length;
  const daysOff = slots.filter((s) => !s.isAvailable).length;
  const workingDaysText =
    slots
      .filter((s) => s.isAvailable)
      .map((s) => DAYS_OF_WEEK.find((d) => d.value === s.dayOfWeek)?.short)
      .join(', ') || 'None';

  return (
    <div className="bg-gray-50 dark:bg-slate-800/50 rounded-lg p-4 border border-gray-200 dark:border-slate-700">
      <h3 className="font-medium text-gray-900 dark:text-slate-100 mb-2">Weekly Summary</h3>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 text-sm">
        <div>
          <p className="text-gray-500 dark:text-slate-400">Days Available</p>
          <p className="text-xl font-bold text-gray-900 dark:text-slate-100">{availableDays}</p>
        </div>
        <div>
          <p className="text-gray-500 dark:text-slate-400">Days Off</p>
          <p className="text-xl font-bold text-gray-900 dark:text-slate-100">{daysOff}</p>
        </div>
        <div className="col-span-2 sm:col-span-2">
          <p className="text-gray-500 dark:text-slate-400">Working Days</p>
          <p className="text-sm font-medium text-gray-900 dark:text-slate-100">{workingDaysText}</p>
        </div>
      </div>
    </div>
  );
};
